// Keep each metric consistent across pages, legends, and tooltips.
// Golden yellow stays more visible on white charts than bright lemon yellow.
export const growthChartColors = {
  totalUsers: "#2563eb",
  activeWebsites: "#16a34a",
  totalWebsites: "#dc2626",
  newSignups: "#ca8a04",
  newWebsites: "#9333ea",
};

export const aiChartColors = {
  totalCredits: "#9333ea",
  totalCreditsFill: "rgba(147, 51, 234, 0.08)",
  freshWebsites: "#dc2626",
  websiteEdits: "#16a34a",
  otherTools: "#ca8a04",
};
